"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var useAppConfiguration = function useAppConfiguration() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.appConfiguration;
    }),
    domain = _useSelector.domain,
    language = _useSelector.language,
    host = _useSelector.host;
  return {
    domain: domain,
    language: language,
    host: host
  };
};
var _default = useAppConfiguration;
exports["default"] = _default;